import classNames from 'classnames'
import { FormikProps } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { POSOrderDetails } from '../../../features/pos-module'
import { useAppSelector } from '../../../hooks'
import { useCreateOrderMutation } from '../../../redux-toolkits/orders/orders.slice'
import {
  FulfilmentType,
  SingleOrder,
} from '../../../redux-toolkits/orders/orders.type'
import { Button } from '../../button'
import Icon from '../../icon'

const fulfilmentTypes: {
  title: string
  icon: string
  value: FulfilmentType
  disabled: boolean
}[] = [
  {
    title: 'Pickup',
    icon: 'storefront',
    value: 'PICKUP',
    disabled: false,
  },
  {
    title: 'Delivery',
    icon: 'truck',
    value: 'DELIVERY',
    disabled: true,
  },
]

export const POSFulfilmentTypeModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (order: SingleOrder, isOpenOrder: boolean) => void
  formik: FormikProps<POSOrderDetails>
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
  formik,
}) => {
  const { currentCart } = useAppSelector((state) => state.auth)

  const [createOrder, { isLoading: creatingOrder, originalArgs }] =
    useCreateOrderMutation()

  const { values, setFieldValue } = formik

  const handleProceed = async (isOpenOrder: boolean) => {
    const resp = await createOrder({
      payload: {
        channel: 'POP',
        delivery: {
          type: values.fulfilmentType,
        },
        personalInformation: {
          firstName: values.customerName.split(' ')[0] ?? '',
          lastName: values.customerName.split(' ')[1] ?? '',
          email: values.customerEmail,
          phone: values.customerPhone ?? '',
        },
        cartId: currentCart ?? '',
        fulfilmentCentreId: values.fulfilmentCenter?._id ?? '',
        recipientsInformation: {
          note: values.orderNote,
        },
        userId: values.customerId || undefined,
        tableNumber: values.tableNumber,
        isOpenOrder: isOpenOrder,
        // createGoodAccount: values.createGoodAccount ?? false,
      },
    })

    if (resp.data?.success) {
      onSuccessCallback(resp.data.data, isOpenOrder)
    }
  }

  return (
    <ModalComponent
      open={open}
      setOpen={creatingOrder ? () => {} : setOpen}
      onCloseCallback={() => {
        if (!creatingOrder) {
          onCloseCallback()
        }
      }}
      title={'Select fulfillment type'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col items-center justify-center gap-4">
        {fulfilmentTypes.map((method) => {
          return (
            <button
              key={method.value}
              disabled={method.disabled}
              type="button"
              className={classNames(
                'p-4 flex items-center w-full border rounded-md  gap-2 disabled:opacity-50 disabled:cursor-not-allowed',
                {
                  'border-divider-gray': method.value !== values.fulfilmentType,
                  'border-primary text-primary':
                    method.value === values.fulfilmentType,
                },
              )}
              onClick={() => {
                setFieldValue('paymentMethod', method.value)
              }}
            >
              <Icon id={method.icon} width={24} height={24} />
              <span>{method.title}</span>
            </button>
          )
        })}

        <Button
          label="Proceed to pay"
          type="button"
          className="mt-2 w-full"
          disabled={creatingOrder && !originalArgs?.payload.isOpenOrder}
          loading={creatingOrder && !originalArgs?.payload.isOpenOrder}
          primary
          onClick={() => {
            handleProceed(false)
          }}
        />

        <Button
          label="Pay later"
          type="button"
          className="mt-2 w-full"
          disabled={creatingOrder && originalArgs?.payload.isOpenOrder}
          loading={creatingOrder && originalArgs?.payload.isOpenOrder}
          primary={false}
          variant="plain"
          onClick={() => {
            handleProceed(true)
          }}
        />
      </div>
    </ModalComponent>
  )
}
